import { useAuthBearerFetch } from "matsuri-hooks"
import { PhotoTour } from "./usePhotoTour"
import { m2mCleaning_cleanerV3 } from "@/endpoints/m2m-cleaning.cleaner-v3"

type OperationId = string
export type PhotoTourByOperationId = Record<OperationId, PhotoTour>

export const usePhotoTourByOperationIds = (
    token: string,
    operationIds?: string[]
) => {
    const endpoint = m2mCleaning_cleanerV3.listPhotoToursByCleaningIdsForCleaner

    return useAuthBearerFetch<PhotoTourByOperationId>(
        token,
        operationIds && operationIds.length > 0 ? endpoint() : null,
        {
            body: JSON.stringify({ cleaningIds: operationIds }),
            method: endpoint.method
        }
    )
}
